// extracted by mini-css-extract-plugin
module.exports = {"dpu-detail-JP4":"JP4_dpu-detail-JP4__JeB2a"};